import { Observable } from 'rxjs';
import Axios from 'axios-observable';

const Domain = process.env.REACT_APP_MAIN_API_SERVER;

class Languages {
    get() {
        return new Observable(subscriber => {
            Axios.get(Domain + '/languages/').subscribe(resp => {
                subscriber.next(resp.data.languages);
                subscriber.complete();
            });
        })
    }
}
export default new Languages();